module.exports = "/* app-footer {\r\n    display: none;\r\n} */"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/quote/quote.component.css
// module id = ./src/app/components/quote/quote.component.css
// module chunks = main